export default __webpack_public_path__ + "static/media/sb.89fab2fd.svg";